import {
    ChildContext, LoggerContext, LogObject, Transform, TransformResult,
} from 'src/types';

export const createBindingsTransform = (
    bindings: ChildContext,
): Transform => (
    message: LogObject,
    context: LoggerContext,
): TransformResult => {
    const modifiedContext = {
        ...context,
        ...bindings,
    };

    return { message, context: modifiedContext };
};
